import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Slide, TextareaAutosize } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { color } from "@mui/system";
import { comment } from "postcss";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export default function ConfirmationModel({
	isOpen,
	setIsOpen,
	title,
	content,
	handleClick,
	color,
	handleChange,
	remark,
}) {
	const [_remark, set_remark] = useState();
	return (
		<div>
			<Dialog
				open={isOpen}
				onClose={() => {
					set_remark();
					setIsOpen(false);
				}}
				TransitionComponent={Transition}>
				<DialogTitle
					style={{ backgroundColor: color == "error" ? "#d32f2f" : "#2e7d32" }}
					className={`text-white`}>
					{title}
				</DialogTitle>
				<DialogContent className='mt-5'>
					<DialogContentText>{content}</DialogContentText>
					{handleChange && (
						<TextareaAutosize
							aria-label='minimum height'
							minRows={3}
							placeholder={"Type Here..."}
							style={{
								width: "100%",
								border: "2px solid #ccc",
								borderRadius: "4px",
								padding: "8px",
								resize: "none",
								"&:focus": {
									outline: "none",
									border: "1px solid #2196f3",
								},
							}}
							maxLength={100}
							onChange={(e) => {
								handleChange(e.target.value);
								set_remark(e.target.value);
							}}
						/>
					)}
				</DialogContent>
				<DialogActions>
					<Button
						color='error'
						onClick={() => {
							set_remark();
							setIsOpen(false);
						}}
						autoFocus>
						Cancel
					</Button>
					<Button
						disabled={_remark ? false : true}
						variant='contained'
						color={color}
						onClick={() => {
							handleClick();
							set_remark();
							setIsOpen(false);
						}}>
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
